import PropTypes from 'prop-types';

import { Modal, ModalHeader, ModalBody } from '@spotahome/ui-library';

const ListingTagModal = ({ isOpen, onRequestClose, children, headerLabel }) => (
  <Modal
    isOpen={isOpen}
    size="medium"
    contentLabel="modal"
    ariaHideApp={false}
    onRequestClose={onRequestClose}
  >
    <ModalHeader
      label={headerLabel}
      onRequestClose={onRequestClose}
      dataText="listing-tag-modal-close-button"
    />
    <ModalBody>{children}</ModalBody>
  </Modal>
);

ListingTagModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  headerLabel: PropTypes.string.isRequired
};

export default ListingTagModal;
